export class AclModel {
  hasDashboard: boolean;
  hasFirmInformationEdit: boolean;
  hasBilling: boolean;
  hasExportData: boolean;
  hasTeamMemberAdd: boolean;
  hasTeamMemberEdit: boolean;
  hasTeamMemberDelete: boolean;
  hasClientAdd: boolean;
  hasClientView: boolean;
  hasClientEdit: boolean;
  hasClientDelete: boolean;
  hasEngView: boolean;
  hasEngAdd: boolean;
  hasEngEdit: boolean;
  hasEngDelete: boolean;
  hasEngArchive: boolean;
  hasEngReOpen: boolean;
  hasTemplateViewAll: boolean;
  hasTemplateAdd: boolean;
  hasTemplateEdit: boolean;
  hasTimeSummaryView: boolean;
  hasTimeSummaryEdit: boolean;
  hasTimeSummaryDelete: boolean;
  hasEngEditAll: boolean;
  hasTimeSummaryExport: boolean;
  hasEngViewEdit: boolean;
  hasTemplateDelete: boolean;
  hasPlatformExport: boolean;
  hasHeaderFooterEdit: boolean;
  // irregularity, added in the ui!
  hasUserAdd: boolean;
  hasClientAddEditDelete: boolean;
  hasClientEmailInvite: boolean;

  isSuperAdmin: boolean;
  isSupport:boolean;
  isAdmin: boolean;
  isClient: boolean;
  isCms: boolean;
  isPartner: boolean;
  isStaff: boolean;
  accessLevelId: number = 4;
  roleId: number = null;
}
